import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tag } from 'primeng/tag';
import type { SpendingSummaryView } from '../account-detail.model';
import { LinkedAccountsListComponent } from './linked-accounts-list.component';

@Component({
  selector: 'bn-spending-summary',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tag, LinkedAccountsListComponent],
  templateUrl: './spending-summary.component.html',
  styleUrl: './spending-summary.component.scss',
})
export class SpendingSummaryComponent {
  readonly summary = input.required<SpendingSummaryView>();

  cardSeverity(label: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
    const lower = label.toLowerCase();
    if (lower.includes('blocked') || lower.includes('closed')) {
      return 'danger';
    }
    if (lower.includes('active')) {
      return 'success';
    }
    return 'info';
  }
}
